import { inheritSerialization } from 'cerialize'
import Invoice from './invoice'
import { DocumentType } from './interfaces'

@inheritSerialization(Invoice)
export default class Receipt extends Invoice {

  public documentType(): DocumentType {
    return 'receipt'
  }
}
